// Added by Sejune Oh on 2020-02-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
interface ResGetPredefinedUserCustomKeys {
  custom_keys: string[]
}
export const reqGetPredefinedUserCustomKeys = async () => {
  return await axios.get<ResGetPredefinedUserCustomKeys>('/v1/data/config/pre-defined-user-custom-keys')
}
